import { Chip, ChipProps } from '@mui/material';
import React from 'react';
import Box from '@mui/material/Box';
import { helpingMethod } from '../../utils/HelpingMethod';

// Define allowed chip labels based on chipSX keys
type ChipLabel =
  | 'Standard'
  | 'Provision'
  | 'Adjusting'
  | 'Invoiced'
  | 'Acquisition'
  | 'Inactive'
  | 'Active'
  | 'Standard'
  | 'EOM'
  | 'New Building'
  | '2HA'
  | 'ACQ'
  | 'STD'
  | 'S&P Purchase';

// Colors are sourced from theme.palette.chips in primaryTheme

interface ChipsProps extends Omit<ChipProps, 'label'> {
  label: ChipLabel | ''; // empty string allowed
  variant?: 'filled' | 'outlined';
  capitalize?: boolean;
  width?: string;
}

const Chips: React.FC<ChipsProps> = ({
  label,
  variant = 'filled',
  capitalize: _capitalize = true,
  width = 'auto',
  ...props
}) => {
  if (!label) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <Chip
        sx={(theme) => {
          const chips = theme.palette.chips || {};
          // Normalize the label to a common type (e.g., ACQ -> ACQUISITION)
          const chipType = helpingMethod.getChipType(label);
          const chipConfig = chips[chipType] || chips[label] || {};

          const textColor =
            typeof chipConfig.text === 'function' ? chipConfig.text(theme) : chipConfig.text;
          return {
            width,
            height: '25px',
            fontSize: '11px',
            p: '0px 10px',
            '& .MuiChip-label': {
              padding: '5px 10px',
            },
            backgroundColor: chipConfig.bg || undefined,
            color: textColor || undefined,
          };
        }}
        label={label}
        variant={variant}
        {...props}
      />
    </Box>
  );
};

export default Chips;
